( function( global, $ ) {

    $('[gr-tab]').on('click', function(e) {
        e.preventDefault();

        var tabContent = $(this).attr('href');

        $('[gr-tab-content]:not([gr-tab-content="' + tabContent + '"])').removeClass('is-active');
        $('[gr-tab-content="' + tabContent + '"]').toggleClass('is-active');

        var tabTriggers = $('[gr-tab]:not([href="' +tabContent + '"])');

        for (var i = 0; i < tabTriggers.length; i++) {
            global.methods.removeAttributeValue(tabTriggers[i], 'gr-tab', 'active', true);
        }

        global.methods.toggleAttributeValue($(this)[0], 'gr-tab', 'active', true);
    });

}( window.groots, jQuery ));
